import React from 'react'

import StartEducationalPathwayScreen from '../../screens/StartEducationalPathwayScreen'

const StartEducationalPathway = () => {
  return <StartEducationalPathwayScreen></StartEducationalPathwayScreen>
}

export default StartEducationalPathway
